"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpiritOfTheTreantAbilityHandler = exports.SpiritOfTheTreantActorAbilityFactory = exports.SpiritOfTheTreantAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const __1 = require("../..");
class SpiritOfTheTreantAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SpiritOfTheTreant;
        this.__typeName = "SpiritOfTheTreant";
    }
}
exports.SpiritOfTheTreantAbilityArgs = SpiritOfTheTreantAbilityArgs;
let SpiritOfTheTreantActorAbilityFactory = class SpiritOfTheTreantActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SpiritOfTheTreant", "Self", 6);
    }
};
SpiritOfTheTreantActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SpiritOfTheTreant")
], SpiritOfTheTreantActorAbilityFactory);
exports.SpiritOfTheTreantActorAbilityFactory = SpiritOfTheTreantActorAbilityFactory;
let SpiritOfTheTreantAbilityHandler = class SpiritOfTheTreantAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        // TODO: Oh crap, really need to make a `MimicVfxStepArgs` so I can swap the actor's designated spine file, boggar spell steal will need this too
        // description: Transforms the caster into a treant. Increases the caster's Focus, Will and Agility by 2 * caster caster level. Removes the cooldown on Nature's Regeneration and Forest's Rejuvination.
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            duration: Duration_1.Duration.Turns(4),
            effect: new __1.LinkedEffectsEffectArgs([
                new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Will, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Will")),
                new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Focus")),
                new __1.LinkedEventHandlerEffectArgs("Treant Form", "Resets the cooldown of Nature's Regeneration and Forest's Rejuvination ", false, container.registerEventHandlerScript(ability.invokerId, __1.EventType.AbilityUsed, __1.Schedule.Unlimited, "Effect_TreantForm_OnTurnEnded", {}))
            ], false)
        });
    }
};
SpiritOfTheTreantAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SpiritOfTheTreant)
], SpiritOfTheTreantAbilityHandler);
exports.SpiritOfTheTreantAbilityHandler = SpiritOfTheTreantAbilityHandler;
